import React from 'react';
import {Header, Card, Grid, Button, Icon, Dimmer, Loader} from 'semantic-ui-react';
import { Alert } from 'componentLibrary';
const ViewSingleSubapplicationCard = ({
  data,
  getApplicationTypeLabel,
  handleAddSingleSubApplication,
  searchAgain,
  categorySelect,
  categoryType,
  subAppAlreadyLinked,
  loading,
  showError,
  errorToShow,
  addingSubApp,
  isAddingToAmendment, 
  searchOption
}) => {
  return (
    <React.Fragment>
      {addingSubApp && (
            <Dimmer active page>
              <Loader>Adding subapplication...</Loader>
            </Dimmer>
          )}
      <Header as="h3">Is this the correct {searchOption === 'subgrant' ? 'subgrant' : 'subapplication'} you would like to add?</Header>
      <Card fluid>
        <Card.Content>
          <Grid>
            <Grid.Row>
              {searchOption === 'subgrant' && <Grid.Column width={4}>Subgrant ID</Grid.Column>}
              <Grid.Column width={4}>Subapplication title</Grid.Column>
              <Grid.Column width={4}>Subapplication type</Grid.Column>
              <Grid.Column width={4}>Subapplicant</Grid.Column>
            </Grid.Row>
            <Grid.Row>
              {searchOption === 'subgrant' && <Grid.Column width={4}>{data.subGrantId}</Grid.Column>}
              <Grid.Column width={4}>{searchOption === 'subgrant' ? data.applicationTitle : data.title}</Grid.Column>
              <Grid.Column width={4}>
                {getApplicationTypeLabel(data.applicationType)}
              </Grid.Column>
              <Grid.Column width={4}>{data.subApplicantTitle}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
      <br />
      {categorySelect ? categorySelect: '' }
      <br />
      <Button
        primary
        icon
        id="addSubApplicationButton"
        title={isAddingToAmendment ? 'Yes, add subamendment ' : 'Yes, add subapplication(s)  '}
        onClick={() => handleAddSingleSubApplication()}
        disabled={
          data === undefined || data.title === undefined || (categorySelect && !categoryType) || (categorySelect && loading)
        }
      >
        {isAddingToAmendment ? 'Yes, add subamendment ' : `Yes, add subapplication(s)  `}
        <Icon name="checkmark" fitted />
      </Button>
      {`  `}
      <a
        id="addSubApplication_tryNewSearch"
        href="#/"
        onClick={(event) => searchAgain(event)}
      >
        <Icon name="undo" />
        No, try a new search
      </a>

      {showError ? (
         <Alert
         size="small"
         header={errorToShow ? errorToShow : 'Unable to attach the subapplication. Please try again later.  If issue persists please contact FEMAGO helpdesk for further assistance.'}
         type="error"
         dismissable={false}
       >
       </Alert>):''
      }
      {subAppAlreadyLinked ? (
        <Alert size="tiny" type="error" dismissable={false}>
          This subapplication is already linked to another application.
        </Alert>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default ViewSingleSubapplicationCard;
